
import { Component, Vue } from "vue-property-decorator";
import apiService from "../../services/apiService/apiService";
import {
  BoundUser,
  LoginCredentialsDto
} from "@/services/apiService/api.types";
import { Action, Mutation } from "vuex-class";
import { AuthAction, Direction } from "./types";
import { Namespace } from "@/store/types";
import storageService from "@/services/storageService/storageService";
import router from "@/router";
import { RouteName } from "@/router/types";
import apiStorageInterface from "@/services/apiStorageInterface";
import Alert from "@/components/alert/Alert.vue";
import {
  ChannelChangeAction,
  ChannelChangeMutation
} from "../channelChange/types";
import { OverlayAction } from "@/components/overlay/types";
import { LocalStorageItems } from "@/helpers/constants";

@Component({
  components: {
    Alert
  }
})
export default class Login extends Vue {
  @Action(AuthAction.logIn, { namespace: Namespace.Auth })
  login!: (logInCredentials: LoginCredentialsDto) => Promise<void>;

  @Action(ChannelChangeAction.UpdateSource, {
    namespace: Namespace.ChannelChange
  })
  updateSource!: (src: string) => Promise<void>;

  @Action(ChannelChangeAction.UpdateOffset, {
    namespace: Namespace.ChannelChange
  })
  updateOffset!: (offset: number) => Promise<void>;

  @Action(OverlayAction.UpdateChannelEpg, {
    namespace: Namespace.Overlay
  })
  updateChannelEpg!: () => Promise<void>;

  @Mutation(ChannelChangeMutation.SetChannelId, {
    namespace: Namespace.ChannelChange
  })
  setChannelId!: (channelId: number) => Promise<void>;

  loading = false;

  logInCredentials: LoginCredentialsDto = {
    username: "",
    password: ""
  };
  shownUserIndex = 0;
  boundUsers: BoundUser[] | null = null;

  Direction = Direction;

  async created(): Promise<void> {
    try {
      // storageService.clear();
      this.boundUsers = await apiService.getBoundUsers();
      if (this.boundUsers && this.boundUsers.length !== 0) {
        this.logInCredentials.username =
          this.boundUsers[this.shownUserIndex].username;
      }
    } catch {
      //TODO: handle error
    }
  }

  async mounted(): Promise<void> {
    if (
      this.$route.name === RouteName.Login &&
      storageService.hasItem(LocalStorageItems.Token)
    ) {
      await this.$router.push({ name: RouteName.Home });
    }
  }

  async logIn(): Promise<void> {
    try {
      this.loading = true;
      await this.login(this.logInCredentials);
      const channelList = await apiStorageInterface.fetchCustomChannelList();

      await Promise.all([
        this.updateSource(channelList[0].videoLive),
        this.updateOffset(0),
        this.setChannelId(channelList[0].id),
        this.updateChannelEpg()
      ]);

      await router.push({ name: RouteName.Home });
    } catch (error) {
      this.loading = false;
    }
  }

  listUser(direction: Direction): void {
    if (!this.boundUsers) {
      return;
    }

    if (direction === Direction.Left && this.shownUserIndex > 0) {
      this.shownUserIndex -= 1;
      this.logInCredentials.username =
        this.boundUsers[this.shownUserIndex].username;
    }

    if (
      direction === Direction.Right &&
      this.shownUserIndex < this.boundUsers.length - 1
    ) {
      this.shownUserIndex += 1;
      this.logInCredentials.username =
        this.boundUsers[this.shownUserIndex].username;
    }
  }

  //images and icons for the page
  get logo(): string {
    return require("/src/assets/images/logo.png");
  }

  get arrowLeft(): string {
    return require("/src/assets/svg/left.svg");
  }

  get arrowRight(): string {
    return require("/src/assets/svg/right.svg");
  }
}
